/*
 * Neutral static theme, used when VUE_APP_THEME names no installed @grapevinetrvl
 * package — a tenant with no compiled theme (talma, for one). It is only the
 * pre-fetch default: with VUE_APP_BRANDING_SOURCE=airtable the branding store
 * replaces colour, logo, title, contact details and social links from the
 * Airtable client_branding row as soon as the app boots.
 *
 * `features` are product switches, not branding, so they stay static and off.
 */
export const theme = {
  color: '#343439',
  title: 'YourTrip',
  logo: null,
  favicon: null,
  info: {
    companyName: '',
    site: '',
    email: '',
    phone: ''
  },
  url: '',
  socialLinks: {},
  features: {
    costAllocationReference: false,
    homeNewToButton: false
  }
};
